<template>
  <el-dialog
    width="990px"
    title="税收分类编码查询"
    :visible.sync="dialogTableVisibletextarea"
    custom-class="sorting-code-number diol-class"
    :before-close="handleClose"
  >
    <div class="el-dialog__body-header">
      <span class="title">税收分类</span>
      <el-search
        :formProp="form"
        :showIndex="0"
        @search="search"
        @change="change"
        width="405px"
      >
        <template slot="search">
          <el-input
            v-model.trim="form.mergeCode"
            clearable
            searchLabel="税收分类编码"
            placeholder="请输入税收分类编码查询"
          ></el-input>
          <el-input
            v-model.trim="form.goodsName"
            clearable
            searchLabel="货物和劳务名称"
            placeholder="请输入货物或劳务名称模糊查询"
          ></el-input>
          <el-input
            v-model.trim="form.keyWord"
            clearable
            searchLabel="关键字"
            placeholder="请输入关键字模糊查询"
          ></el-input>
        </template>
      </el-search>
    </div>
    <div
      style="overflow:hidden !important;height:440px !important;max-height:440px !important;min-height:440px !important;"
      class="el-dialog__body-bodys"
    >
      <div class="bodys-left">
        <el-tree
          v-if="dialogTableVisibletextarea"
          :props="treeProps"
          ref="tree"
          node-key="taxCode"
          :load="loadNode"
          :check-strictly="true"
          :default-checked-keys="defaultKey"
          :default-expanded-keys="defaultKey"
          :expand-on-click-node="false"
          :check-on-click-node="true"
          @node-click="handleNodeClick"
          draggable
          lazy
        >
        </el-tree>
      </div>
      <div class="bodys-right">
        <el-table
          :data="tableData"
          :lineClamp="lineClampBody"
          max-height="380"
          style="width: 700px"
        >
          <el-table-column prop="mergeCode" label="税收分类编码" width="180">
          </el-table-column>
          <el-table-column prop="goodsName" label="货物和劳务名称">
          </el-table-column>
          <el-table-column prop="vatRate" label="增值税税率" width="100">
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="remark"
            label="说明"
          >
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="scope" style="margin-top: -11px">
              <el-button
                size="mini"
                :class="scope.row.button === false ? '' : 'checked'"
                plain
                type="single-number-filleted"
                @click="handleClick(scope.row)"
                >{{ scope.row.button === false ? "选择" : "已选择" }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div
          class="table-footer"
          style="height:40px;margin-top:20px;"
          v-if="showPage"
        >
          <div class="ccui-table-footer">
            <div id="ccui-paging">
              <el-pagination
                :total="total"
                :pager-count="5"
                :page-size="paramsTable.pageSizeCode"
                :current-page="paramsTable.pageNoCode"
                prev-text="< 上一页"
                next-text="下一页 >"
                background
                :pagesize="pagesize"
                layout="total, prev, pager, next, jumper"
                popper-class="ccui-paging-page-size-popper"
                @prev-click="handlePrev"
                @next-click="handleNext"
                @size-change="handleSizeChange"
                @addCurrentPage="internalCurrentPage"
                @current-change="handleCurrentChange"
              />
              <el-button
                class="ccui-pagination-btn"
                size="mini"
                type="default"
                @click="handleGoPage"
                >确定</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        size="mini"
        type="default-mini"
        @click="$emit('update:dialogTableVisibletextarea', false)"
        >取 消</el-button
      >
      <el-button size="mini" type="primary-font-mini" @click="closeTaxRate"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { queryTaxCodeTree, queryTaxCodeList } from "@/views/lessor-open-shop/api.js";

export default {
  name: "tax-rate",
  props: ["dialogTableVisibletextarea"],
  data() {
    return {
      showPage: true,
      lineClampBody: true,
      defaultKey: [1],
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          button: false,
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          button: false,
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ],
      treeProps: {
        label: "goodsName",
        id: "taxCode",
        level: "codeLevel",
        children: "data",
        isLeaf: "isEnd"
      },
      paramsTable: {
        taxCode: "1",
        pageSizeCode: 10,
        pageNoCode: 1,
        isShowPageLoading: true
      },
      props: {
        multiple: true,
        lazy: true,
        lazyLoad(node, resolve) {
          queryTaxCodeTree({ taxCode: node.value || "0" }).then(res => {
            resolve(res.data.data);
          });
        }
      },
      gridData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ],
      form: {
        mergeCode: "",
        goodsName: "",
        keyWord: ""
      },
      textarea: "",
      formLabelWidth: "120px",
      present: "",
      total: 1,
      recordsTotal: 1,
      lastTime: {
        button: false
      },
      pagesize: [10]
    };
  },
  watch: {
    dialogTableVisibletextarea(val) {
      if (val == true) {
        this.showPage = true;
        this.paramsTable = {};
        this.paramsTable.taxCode = "1";
        this.form.mergeCode = "";
        this.form.goodsName = "";
        this.form.keyWord = "";
        this.lastTime = {
          button: false
        };
        this._queryTaxCodeList();
      }
    }
  },
  created() {
    this._queryTaxCodeList();
  },
  methods: {
    _queryTaxCodeList() {
      this.paramsTable.pageNo = this.paramsTable.pageNoCode;
      this.paramsTable.pageSize = this.paramsTable.pageSizeCode;
      var obj = {};
      obj = JSON.parse(JSON.stringify(this.paramsTable));
      if (obj.keyWord != undefined) {
        delete obj["taxCode"];
      }
      queryTaxCodeList(obj).then(res => {
        res.data.data.rows.forEach(item => {
          item.button = false;
        });
        if (res.data.data.total === 1) {
          this.showPage = false;
        } else if (res.data.data.total > 1) {
          this.showPage = true;
        }
        this.total = res.data.data.total;
        this.recordsTotal = res.data.data.recordsTotal;
        this.tableData = res.data.data.rows;
      });
    },
    closeTaxRate() {
      console.log(this.lastTime);
      if (this.lastTime.button != false) {
        let obj = JSON.parse(JSON.stringify(this.lastTime));
        if (obj.vatRate.indexOf("、") !== -1) {
          obj.vatRate = "";
        }
        this.$emit("taxCodeSelected", obj);
        this.$emit("update:dialogTableVisibletextarea", false);
      } else {
        this.$message({
          message: "请选择税控编码。",
          type: "error",
          duration: 0,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    handleClick(val) {
      console.log(val);
      val.button = true;
      if (val.mergeCode !== this.lastTime.mergeCode) {
        this.lastTime.button = false;
        this.lastTime = val;
      }
    },
    handleSizeChange(val) {
      this.paramsTable.pageNoCode = 1;
      val !== "none" && (this.paramsTable.pageSizeCode = val);
      this._queryTaxCodeList();
    },
    handleClose() {
      this.$emit("update:dialogTableVisibletextarea", false);
    },
    handleNodeClick(val) {
      this.form.mergeCode = "";
      this.form.goodsName = "";
      this.form.keyWord = "";
      console.log("树 当前选中", val);
      let valId = [val.id];
      this.$refs.tree.setCheckedKeys(valId);
      delete this.paramsTable.mergeCode;
      delete this.paramsTable.goodsName;
      delete this.paramsTable.keyWord;
      this.paramsTable.pageNoCode = 1;
      this.paramsTable.pageSizeCode = 10;
      this.paramsTable.taxCode = val.taxCode;
      this._queryTaxCodeList();
    },
    handleCurrentChange(val) {
      this.paramsTable.pageNoCode = val;
      this._queryTaxCodeList();
    },
    internalCurrentPage(val) {
      this.pageNoCode = val;
    },
    handlePrev() {},
    handleNext() {},
    handleGoPage() {},
    loadNode(node, resolve) {
      queryTaxCodeTree({ taxCode: node.data ? node.data.taxCode : "0" }).then(
        data => {
          console.log(data);
          /**这里需要修改**/
          if (data.data.code === "0") {
            if (!node.data || !node.data.taxCode) {
              this.defaultKey = [data.data.data[0].taxCode];
            }
            data.data.data.forEach(item => {
              item.value = item.taxCode;
              item.isEnd = item.isEnd ? true : false;
            });
            const nodes = data.data.data;
            resolve(nodes);
          }
        }
      );
    },
    search(searchData) {
      this.paramsTable.pageNoCode = 1;
      this.paramsTable.pageSizeCode = 10;
      delete this.paramsTable["keyWord"];
      delete this.paramsTable["mergeCode"];
      delete this.paramsTable["goodsName"];
      console.log(this.paramsTable);

      Object.assign(this.paramsTable, searchData);
      this._queryTaxCodeList();
      console.log(this.paramsTable);
      console.log("搜索输入", searchData);
    },
    change(index, key, value) {
      console.log("当前所选组件的 index=" + index);
      console.log("当前所选组件的 key=" + key);
      console.log("当前所选组件的 value=" + value);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  max-height: 486px !important;
  min-height: 486px !important;
  height: 486px !important;
  overflow: hidden;
}
</style>
